import SupervisorCreate from 'components/supervisor/SupervisorCreate';
import SupervisorDashboard from 'components/dashboard/supervisor/SupervisorDashboard';
import SupervisorEdit from 'components/supervisor/SupervisorEdit';
import SupervisorList from 'components/supervisor/SupervisorList';
import SupervisorProfile from 'components/supervisor/SupervisorProfile';
import DefaultLayout from 'components/layout/DefaultLayout';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const supervisorRoutes = [
  {
    key: 'supervisor-dashboard',
    exact: true,
    path: routes.dashboardSupervisor.path,
    component: SupervisorDashboard,
    layout: DefaultLayout,
    allowedRoles: [roles.supervisor]
  },
  {
    key: 'supervisor-profile',
    exact: true,
    path: routes.supervisorProfile.path,
    component: SupervisorProfile,
    layout: DefaultLayout,
    allowedRoles: [roles.supervisor]
  },
  {
    key: 'supervisor-create',
    exact: true,
    path: routes.createSupervisor.path,
    component: SupervisorCreate,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'supervisor-edit',
    exact: true,
    path: routes.editSupervisor.path,
    component: SupervisorEdit,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'supervisor-list',
    exact: true,
    path: routes.listSupervisor.path,
    component: SupervisorList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  }
];

export default supervisorRoutes;
